import Vue from "vue";
import { Prop, Component, Watch } from "vue-property-decorator";

import { State, namespace, Action } from "vuex-class";
const module = namespace("dbModule");

@Component
export default class TableLayout extends Vue {
  @Prop()
  protected tableId!: string;

  @Prop()
  protected tableConfig!: ITableState;

  private isFetchData = false;

  protected innerHeaders: any[] = [];

  @module.Action("fetchTableData")
  private actionFetchConfig; // 获取表格配置

  @module.State(state => state.currentId)
  private stateCurrentTableId;

  @module.State(state => state.tables)
  private tablesState: ITableSetState;

  @Watch("tablesState")
  private observeState() {
    if (this.tableId === this.stateCurrentTableId) {
      this.reLayout();
    }
  }

  @Watch("tableId")
  protected reLayout() {
    this.updateHeaders();
  }

  // @Watch("stateCurrentTableId")
  protected updateHeaders() {
    if (this.tableId) {
      let state: ITableState = this.tablesState[this.tableId];
      if (state && state.headers) {
        this.innerHeaders = state.headers as any[];

        this.$emit("update:tableConfig", state);
        this.$emit("update:headers", this.innerHeaders);
      } else if (!this.isFetchData) {
        this.fetchLayoutData();
      }
    }
  }

  protected async fetchLayoutData() {
    if (this.tableId) {
      this.$setLoading(true);
      this.isFetchData = true;
      await this.actionFetchConfig(this.tableId);
      this.isFetchData = false;
      this.$setLoading(false);
    }
  }

  created() {
    this.reLayout();
  }
}
